module.exports = __webpack_public_path__ + "static/shapes-blue-orange-yellow-9cb3eeaf3174dfa28eebd316f7e18274.png";